import * as R from 'ramda';
import { createLogic } from 'redux-logic';
// feature lite-new-do
import {
  getStopTitle,
  getDataFromStops,
  getValidationWarnings,
  isStopsQuantityLessOrEqualTwo,
} from '../new-do/helpers';
import {
  isDropFormValid,
  isPickupFormValid,
  isValidReferencesForm,
  isValidStopReferencesForm,
} from '../new-do/validation';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature lite-new-do
import * as A from './actions';
import { isValidBillToCustomerRateForm } from './validation';
//////////////////////////////////////////////////

const handleGetBranchConfigsSuccess = createLogic({
  type: [
    A.getBranchConfigsSuccess,
    A.getBranchConfigsWithTemplateSuccess,
  ],
  validate({ getState, action }, allow) {
    allow(action);
  },
  process({ getState, action }, dispatch, done) {
    const { branchConfigs } = action.payload;

    const primaryReferenceSequenceGuid = G.getConfigValueFromStore(
      GC.CLO_PRIMARY_REFERENCE_SEQUENCE, branchConfigs,
    );

    if (G.shouldGetPrimaryRefSequenceFromBranchConfigs(branchConfigs)) {
      dispatch(A.getPrimaryRefSequenceRequest(primaryReferenceSequenceGuid));
    }

    done();
  },
});

const handleRemoveStopFromStore = createLogic({
  type: A.removeStopFromStore,
  validate({ getState, action }, allow, reject) {
    const order = action.payload;
    const state = getState();
    const store = state.liteNewDO;
    const stops = store.stops;

    const { firstStop } = getDataFromStops(stops);

    if (isStopsQuantityLessOrEqualTwo(stops)) {
      G.showToastrMessageFromLocale('info', 'messages:min-two-stops-to-create-clo');

      return reject();
    }

    if (R.and(R.equals(order, 1), G.isStopPickup(firstStop))) {
      G.showToastrMessageFromLocale('info', 'messages:cant-delete-first-pickup');

      return reject();
    }
    allow(action);
  },
});

const getInvalidNames = (invalidName, isObjectValid, invalidNames) => {
  if (G.isTrue(isObjectValid)) {
    return invalidNames;
  }

  return R.append(invalidName, invalidNames);
};

const validateCustomerRate = (rate) => {
  const isValid = G.getPropFromObject('isValid', rate);

  return R.and(isValidBillToCustomerRateForm(rate), isValid);
};

const getInvalidFormsMsg = (store) => {
  const { stops, rateBackup, referenceFormData } = store;

  let errorNames = [];
  const { sortedStops, stopReferences } = getDataFromStops(stops);

  const isValidRate = validateCustomerRate(rateBackup);
  const isValidReferences = isValidReferencesForm(referenceFormData);
  const isValidStopReferences = isValidStopReferencesForm(stopReferences);

  errorNames = getInvalidNames('Rate Fields', isValidRate, errorNames);
  errorNames = getInvalidNames('Additional Info', isValidReferences, errorNames);
  errorNames = getInvalidNames('Stop References', isValidStopReferences, errorNames);

  R.forEach((stop) => {
    const { formData, eventType } = stop;

    const title = getStopTitle(stop);

    const validationFunc = G.ifElse(
      G.isEventTypePickup(eventType),
      isPickupFormValid,
      isDropFormValid,
    );

    const isValid = validationFunc(formData);

    errorNames = getInvalidNames(title, isValid, errorNames);
  }, sortedStops);

  return errorNames;
};

const handleSendDataToApiRequest = createLogic({
  type: A.sendDataToApiRequest,
  validate({ getState, action }, allow, reject) {
    const state = getState();
    const store = state.liteNewDO;

    const { stops } = store;

    const errors = getInvalidFormsMsg(store);
    const warnings = getValidationWarnings(store);

    if (R.or(G.isNotNilAndNotEmpty(errors), G.isNotNilAndNotEmpty(warnings))) {
      return reject(A.setValidationErrorsAndWarnings({ errors, warnings }));
    }

    const { lastStop, firstStop } = getDataFromStops(stops);

    if (G.isStopDrop(firstStop)) {
      G.showToastrMessageFromLocale('info', 'messages:cant-delete-first-pickup');

      return reject();
    }

    if (G.isStopPickup(lastStop)) {
      G.showToastrMessageFromLocale('info', 'messages:last-stop-should-be-drop');

      return reject();
    }

    allow(action);
  },
});

const handleGetAdditionalRefSequenceLogic = createLogic({
  type: [
    A.getBranchConfigsSuccess,
    A.copyTemplateDataToStore,
    A.getBranchConfigsWithTemplateSuccess,
  ],
  validate({ getState, action }, allow) {
    allow(action);
  },
  process({ getState, action }, dispatch, done) {
    let branchConfigs = R.path(['payload', 'branchConfigs'], action);

    if (G.isNilOrEmpty(branchConfigs)) {
      branchConfigs = R.path(['liteNewDO', 'branchConfigs'], getState());
    }

    const additionalReferenceAutogenerated = G.getConfigValueFromStore(
      GC.CLO_ADDITIONAL_REFERENCE_AUTOGENERATED,
      branchConfigs,
    );

    if (additionalReferenceAutogenerated) {
      const sequenceGuid = G.getConfigValueFromStore(
        GC.CLO_ADDITIONAL_REFERENCE_SEQUENCE,
        branchConfigs,
      );

      dispatch(A.getAdditionalRefSequenceRequest({ sequenceGuid }));
    }

    done();
  },
});

export default [
  handleGetAdditionalRefSequenceLogic,
  //
  handleRemoveStopFromStore,
  handleSendDataToApiRequest,
  handleGetBranchConfigsSuccess,
];
